import jquery  from "jquery";
import ko      from 'knockout';
import {formatMessage}          from '@mks/dev/localization';
import {makePasswordViewButton} from "@KsaContent/js/Login/Utils";

export class KsaChangePasswordViewModel {
    _popup;
    _form;
    _options;
    messageHtml = ko.observable('');

    constructor() {}
}

/* Инициализация диалога изменения пароля */
KsaChangePasswordViewModel.prototype.getPopupOptions = function() {
    const self = this;
    return {
        wrapperAttr: {
            class: 'ksa-popup'
        },
        height: 'auto',
        width: 440,
        maxHeight: 'calc(100vh - 12px)',
        maxWidth: 'calc(100vw - 12px)',
        showTitle: false,
        visible: false,
        hideOnOutsideClick: false,
        focusStateEnabled: false,
        contentTemplate: document.getElementById('ksa-login-change-password-popup-content'),
        onInitialized: function(e) {
            self._popup = e.component;
        },
        onShowing: self._onPopupShowing,
        animation: {
            show: {
                type: 'pop'
            }
        }
    };
};

/** Получение параметров формы изменения пароля.
 *  @returns параметры формы изменения пароля. */
KsaChangePasswordViewModel.prototype.getFormOptions = function () {
    const self = this;
    return {
        scrollingEnabled: true,
        focusStateEnabled: false,
        labelMode: 'floating',
        onInitialized: function(e) {
            self._form = e.component;
        },
        items: [{
            itemType:  'simple',
            dataField: 'passwordOld',
            cssClass:  'ksa-login-input',
            label: {
                text: formatMessage('KsaLoginId.ChangePassword.PasswordOld')
            },
            editorType: 'dxTextBox',
            editorOptions: {
                elementAttr: {
                    class: 'ksa-password-editor'
                },
                height: 56,
                onEnterKey: () => self._changePasswordHandler(),
                mode: 'password',
                buttons: [makePasswordViewButton()]
            }
        }, {
            itemType:  'simple',
            dataField: 'passwordNew',
            cssClass:  'ksa-login-input',
            label: {
                text: formatMessage('KsaLoginId.ChangePassword.PasswordNew')
            },
            editorType: 'dxTextBox',
            editorOptions: {
                elementAttr: {
                    class: 'ksa-password-editor'
                },
                height: 56,
                onEnterKey: () => self._changePasswordHandler(),
                mode: 'password',
                buttons: [makePasswordViewButton()]
            }
        }, {
            itemType: 'simple',
            name:     'passwordNewRepeat',
            cssClass: 'ksa-login-input',
            label: {
                text: formatMessage('KsaLoginId.ChangePassword.PasswordNewRepeat')
            },
            editorType: 'dxTextBox',
            editorOptions: {
                elementAttr: {
                    class: 'ksa-password-editor'
                },
                height: 56,
                onEnterKey: () => self._changePasswordHandler(),
                mode: 'password',
                buttons: [makePasswordViewButton()]
            }
        }, {
            itemType: 'group',
            colCount: 5,
            items: [{
                itemType: 'empty'
            }, {
                itemType: 'button',
                colSpan:  2,
                cssClass: 'ksa-login-button ksa-popup-button',
                horizontalAlignment: 'right',
                buttonOptions: {
                    type:  'default',
                    text:  formatMessage('KsaLoginId.ChangePassword.Change'),
                    height: 40,
                    width: '100%',
                    useSubmitBehavior: true,
                    onClick: () => self._changePasswordHandler()
                }
            }, {
                itemType: 'button',
                colSpan:  2,
                cssClass: 'ksa-login-button ksa-popup-button',
                horizontalAlignment: 'right',
                buttonOptions: {
                    type:  'normal',
                    text:  formatMessage('KsaLoginId.ChangePassword.Cancel'),
                    height: 40,
                    width: '100%',
                    useSubmitBehavior: true,
                    onClick: () => self._cancelHandler()
                }
            }]
        }]
    };
};

/** Обработчик события показа диалога изменения пароля.
 * @param e аргументы события. */
KsaChangePasswordViewModel.prototype._onPopupShowing = function(e) {
    const self = this;
    self.messageHtml(self._options.changePasswordData.message);
    self._form.option('formData', self._options.changePasswordData);
    let passwordChangeRules = [{
        type: 'custom',
        reevaluate: true,
        message: formatMessage('KsaLoginId.ChangePassword.Validation.PasswordMustDiffer'),
        validationCallback: function (options) {
            return options.value !== self._options.authModel.password;
        }
    }];
    let passwordMatchRules = [{
        type: 'custom',
        reevaluate: true,
        message: formatMessage('KsaLoginId.ChangePassword.Validation.PasswordMismatch'),
        validationCallback: function (options) {
            return options.value === self._form.getEditor('passwordNew').option('value');
        }
    }];
    if (self._options.changePasswordData.checkStrength) {
        // Проверка минимальной длины пароля
        const passwordLengthRule = {
            type: 'stringLength',
            min: self._options.changePasswordData.passwordMinLength,
            message: formatMessage('KsaLoginId.ChangePassword.Validation.PasswordMinLength_0', self._options.changePasswordData.passwordMinLength)
        };

        // Проверка наличия строчных букв.
        const lowercaseRequiredRule = {
            type: 'custom',
            reevaluate: true,
            message: formatMessage('KsaLoginId.ChangePassword.Validation.LowercaseLettersRequired'),
            validationCallback: function (options) {
                const stringValue = options.value.toString();
                return stringValue !== stringValue.toUpperCase();
            }
        }

        // Проверка наличия прописных букв.
        const uppercaseRequiredRule = {
            type: 'custom',
            reevaluate: true,
            message: formatMessage('KsaLoginId.ChangePassword.Validation.UppercaseLettersRequired'),
            validationCallback: function (options) {
                const stringValue = options.value.toString();
                return stringValue !== stringValue.toLowerCase();
            }
        }

        // Проверка наличия цифр.
        const digitRequiredRule = {
            type: 'custom',
            reevaluate: true,
            message: formatMessage('KsaLoginId.ChangePassword.Validation.DigitRequired'),
            validationCallback: function (options) {
                return /\d/.test(options.value.toString());
            }
        }

        // Проверка наличия спецсимволов: ~, !, @, #, $, %, ^, &, *, (, ), ?.
        const specialSymbolRequiredRule = {
            type: 'custom',
            reevaluate: true,
            message: formatMessage('KsaLoginId.ChangePassword.Validation.SpecialSymbolRequired'),
            validationCallback: function (options) {
                return /[~!@#$%^&*()?]/.test(options.value.toString());
            }
        }

        passwordChangeRules.unshift(passwordLengthRule, lowercaseRequiredRule, uppercaseRequiredRule, digitRequiredRule, specialSymbolRequiredRule);
        passwordMatchRules .push   (passwordLengthRule, lowercaseRequiredRule, uppercaseRequiredRule, digitRequiredRule, specialSymbolRequiredRule);
    }
    self._form.itemOption('passwordOld',       'visible',         self._options.changePasswordData.passwordOldRequired);
    self._form.itemOption('passwordNew',       'validationRules', passwordChangeRules);
    self._form.itemOption('passwordNewRepeat', 'validationRules', passwordMatchRules);
};

/** Обработчик события изменения пароля.
 *  @param e аргументы события. */
KsaChangePasswordViewModel.prototype._changePasswordHandler = function(e) {
    const self = this;
    let validationResult = self._form.validate();
    if (validationResult.isValid) {
        self._options.changePasswordCallback(self._options.changePasswordData);
    }
};

/** Обработчик события отмены изменения пароля.
 *  @param e аргументы события. */
KsaChangePasswordViewModel.prototype._cancelHandler = function(e) {
    const self = this;
    self._options.cancelCallback(self._options.changePasswordData);
};

/** Показать диалог изменения пароля.
 *  @param options{{authModel: any, changePasswordData: any, changePasswordCallback: function, cancelCallback: function}} параметры */
KsaChangePasswordViewModel.prototype.showDialog = function(options) {
    const self = this;

    self._options = jquery.extend(true, {
        authModel: {
            password: undefined
        },
        changePasswordData: {
            passwordOldRequired: false,
            message: ''
        },
        changePasswordCallback: () => {},
        cancelCallback: () => {},
    }, options || {});

    self._popup?.show();
};
